import { useBoolean } from '@aibees/shared/hooks';
import { createContext, useContext, useState } from 'react';
import { FieldValues, UseFieldArrayReturn } from 'react-hook-form';
import {
  UserManagementContextData as ContextData,
  UserManagementContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useUserManagementContext = () => useContext(context);

export const UserManagementProvider = ({ children }: ContextProps) => {
  const inviteFormVisible = useBoolean(false);
  const [members, setMembers] =
    useState<UseFieldArrayReturn<FieldValues, 'members', 'id'>>();

  return (
    <Provider value={{ inviteFormVisible, members, setMembers }}>
      {children}
    </Provider>
  );
};
